import { render, staticRenderFns } from "./ForwardTo.vue?vue&type=template&id=18452c46&scoped=true&"
import script from "./ForwardTo.vue?vue&type=script&lang=js&"
export * from "./ForwardTo.vue?vue&type=script&lang=js&"
import style0 from "./ForwardTo.vue?vue&type=style&index=0&id=18452c46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18452c46",
  null
  
)

export default component.exports